const initialState = {
    type: '',
    profile_theirs_open: false,
    likesPopupActive: false,
}

export default function sidebar(state = initialState, action) {
    switch(action.type) {
        case 'SET_TYPE':
            return {
                ...state,
                type: action.payload
            }
        case 'SET_PROFILE_OPEN':
            return {
                ...state,
                profile_theirs_open: action.payload
            }
        case 'SET_LIKES_POPUP_ACTIVE':
            return {
                ...state,
                likes_popup_active: action.payload
            }
        
        default:
            return state    
    }
}